// Shared PDF header/footer helpers
import { RIVERBEND_LOGO } from '../assets/riverbendLogo'
import { CP_QUALITY_LOGO } from '../assets/cpQualityLogo'

export function fmtMoney(n) {
  return '$' + Number(n || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
}

export function fmtPct(n) {
  return Number(n || 0).toFixed(1) + '%'
}

export function fmtDatePDF(d) {
  return d ? new Date(d + (d.length === 10 ? 'T12:00:00' : '')).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) : ''
}

export function addRiverbendHeader(doc) {
  try { doc.addImage(RIVERBEND_LOGO, 'PNG', 14, 8, 28, 28) } catch(e) {}
  doc.setFontSize(20)
  doc.setFont('helvetica', 'bold')
  doc.setTextColor(0, 0, 0)
  doc.text('Riverbend Contracting Co.', 46, 18)
  doc.setFontSize(9)
  doc.setFont('helvetica', 'normal')
  doc.setTextColor(80, 80, 80)
  doc.text('11260 Dunham Road  |  Hartland, Michigan 48353', 46, 25)
  doc.text('8109236229  |  Carspie99@gmail.com  |  Riverbendcontractingco.com', 46, 30)
}

export function addPoolsHeaderSimple(doc) {
  try { doc.addImage(CP_QUALITY_LOGO, 'PNG', 14, 8, 26, 26, 'cpq', 'FAST') } catch(e) {}
  doc.setFontSize(24)
  doc.setFont('helvetica', 'bold')
  doc.setTextColor(0, 0, 0)
  doc.text('CP Quality Pools', 105, 22, { align: 'center' })
  doc.setFontSize(10)
  doc.setFont('helvetica', 'normal')
  doc.setTextColor(80, 80, 80)
  doc.text('Pietila Group  |  (810) 923-6229  |  pietilagroup.com', 105, 29, { align: 'center' })
}

export function addPoolsHeaderFancy(doc) {
  // Logo
  try { doc.addImage(CP_QUALITY_LOGO, 'PNG', 14, 9, 22, 22, 'cpq', 'FAST') } catch(e) {}

  // Company name
  doc.setFontSize(22)
  doc.setFont('helvetica', 'bold')
  doc.setTextColor(0, 90, 150)
  doc.text('CP Quality Pools', 38, 16)

  // Tagline
  doc.setFontSize(9)
  doc.setFont('helvetica', 'normal')
  doc.setTextColor(0, 120, 180)
  doc.text('A Pietila Group Company', 38, 22)

  // Contact info line
  doc.setFontSize(9)
  doc.setFont('helvetica', 'normal')
  doc.setTextColor(80, 80, 80)
  doc.text('11260 Dunham Rd, Hartland, MI 48353  |  (810) 923-6229  |  pietilagroup.com', 38, 28)

  // Blue accent line under header
  doc.setDrawColor(0, 120, 180)
  doc.setLineWidth(0.8)
  doc.line(14, 34, 196, 34)
}

export function addFooter(doc, text) {
  var pageCount = doc.internal.getNumberOfPages()
  for (var p = 1; p <= pageCount; p++) {
    doc.setPage(p)
    doc.setFontSize(7)
    doc.setTextColor(150, 150, 150)
    doc.text(text, 105, 287, { align: 'center' })
    doc.text(p + ' of ' + pageCount, 190, 287, { align: 'right' })
  }
}
